<section>
  <div class="report-border">
    <div class="row">
      <div class="col-md-12 header-font text-center color-blue">
        {{'uplinereport.Upline Report' |translate | translateKey}}
        <span class="fa fa-question-circle-o font-size-12 report-title-tooltip"
          popover="{{'uplinereport.My upline FBO details.' |translate | translateKey}}" outsideClick="true"
          container="body" placement="bottom"></span> - <span id="header-countryname"
          class="country-font-size">{{selectedCountry.name}}</span></div>
    </div>
    <div class="row">
      <div class="text-right pad-right-20">
        <b>{{'common.Run Date:' |translate |translateKey}} </b>
        <span class="applyBlock">{{mydate}}</span>
      </div>
    </div>
  </div>


  <div class="row padding-top-15 mb-10">
    <div class="col-md-5">
      <div class="col-md-4 ">{{'uplinereport.Operating Company' |translate | translateKey}}</div>
      <div class="col-md-8">
        <select [(ngModel)]="selectedCountry" id="autofocus-element" tabindex="0" class="form-control"
          (change)="getChangeCountries(selectedCountry.value)">
          <option *ngFor="let country of operatingCountries" [disabled]="country?.disabled"
            [class.isDisable]="country?.disabled" [ngValue]="country">
            {{country.name}}</option>
        </select>
      </div>
    </div>

    <div class="col-md-4" *ngIf="!!selectedHomeCountryValue">
      <div class="col-md-4 " >{{'uplinereport.Home Company' |translate | translateKey}}</div>
      <div class="col-md-6">
        <select [(ngModel)]="selectedHomeCompany" id="autofocus-element" tabindex="1" class="form-control" 
        (change)="getChangeHomeCountry(selectedHomeCompany.operatingCompany)">
          <option *ngFor="let data of homeCompanyData"  [ngValue]="data">
            {{ data.countryDisplayName}}</option>
        </select>
      </div>
    </div>



    <div  [ngClass]=" selectedHomeCountryValue? 'col-md-3' : 'col-md-7' ">
      <input id="search" class="form-control pull-right search-input" (keyup.enter)="searchUplineReportDetais()"
        placeholder="Search" [(ngModel)]="searchTerm">
    </div>
  </div>


  <div class="row">
    <div class="col-md-6 text-right">
      <button type="button" class="orderHistoryButton excel-hide" [disabled]="disableExport==true" (click)="Download('PDF')">
        <span class="btn-label">
          <img class="pdf-image" [src]="pdfIconUrl" alt="PDF Icon">
        </span>
      </button><button type="button" class="orderHistoryButton excel-hide"  [disabled]="disableExport==true" (click)="Download('CSV')">
        <span class="btn-label">
          <img class="excel-image" [src]="excelIconUrl" alt="Excel Icon">
        </span>
      </button>
    </div>
    <div class="col-md-6">
      <div class="pull-right">
        <button tabindex="2" type="submit" class="btn blue-button" (click)="searchUplineReportDetais()">
          {{'customer-service.Search' |translate | translateKey}}</button>

        <button tabindex="2" (click)="clearFields()" type="button" class="btn grey-button" (click)="clearFields()">
          {{'customer-service.Clear' |translate | translateKey}}</button>
      </div>
    </div>
  </div>

  <div class="table-responsive padding-top-15">
    <table class="table table-striped custab">
      <thead>
        <tr class="pointer">
          <th (keyup.enter)="sortUplineReportDetailsByColumn('rowNumber')"
            (click)="sortUplineReportDetailsByColumn('rowNumber')">#
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'rowNumber', 'fa-sort-asc': (sortRecentUplineColumn  == 'rowNumber' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'rowNumber' && isRecentUplineDesc) }"></i>
          </th>
          <th (keyup.enter)="sortUplineReportDetailsByColumn('distributorId')"
            (click)="sortUplineReportDetailsByColumn('distributorId')">
            {{'uplinereport.ID' |translate | translateKey}}
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'distributorId', 'fa-sort-asc': (sortRecentUplineColumn  == 'distributorId' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'distributorId' && isRecentUplineDesc) }"></i>
          </th>
          <th (keyup.enter)="sortUplineReportDetailsByColumn('name')" (click)="sortUplineReportDetailsByColumn('name')">
            {{'uplinereport.FBO Name' |translate | translateKey}}
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'name', 'fa-sort-asc': (sortRecentUplineColumn  == 'name' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'name' && isRecentUplineDesc) }"></i>
          </th>
          <th (keyup.enter)="sortUplineReportDetailsByColumn('state')"
            (click)="sortUplineReportDetailsByColumn('state')">
            {{'uplinereport.State' |translate | translateKey}}
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'state', 'fa-sort-asc': (sortRecentUplineColumn  == 'state' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'state' && isRecentUplineDesc) }"></i>
          </th>
          <th (keyup.enter)="sortUplineReportDetailsByColumn('operatingCompanyCode')"
            (click)="sortUplineReportDetailsByColumn('operatingCompanyCode')">
            {{'uplinereport.Home Country' |translate | translateKey}}
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'operatingCompanyCode', 'fa-sort-asc': (sortRecentUplineColumn  == 'operatingCompanyCode' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'operatingCompanyCode' && isRecentUplineDesc) }"></i>
          </th>
          <th (keyup.enter)="sortUplineReportDetailsByColumn('level')"
            (click)="sortUplineReportDetailsByColumn('level')">
            {{'uplinereport.Level' |translate | translateKey}}
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'level', 'fa-sort-asc': (sortRecentUplineColumn  == 'level' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'level' && isRecentUplineDesc) }"></i>
          </th>
          <th (keyup.enter)="sortUplineReportDetailsByColumn('currentMonthActive')"
            (click)="sortUplineReportDetailsByColumn('currentMonthActive')">
            {{'uplinereport.4CC Active?' |translate | translateKey}}
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'currentMonthActive', 'fa-sort-asc': (sortRecentUplineColumn  == 'currentMonthActive' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'currentMonthActive' && isRecentUplineDesc) }"></i>
          </th>
          <th (keyup.enter)="sortUplineReportDetailsByColumn('distributorStatus')"
            (click)="sortUplineReportDetailsByColumn('distributorStatus')">
            {{'uplinereport.Status' |translate | translateKey}}
            <i class="font-12 fa fa-sort"
              [ngClass]="{'fa-sort': sortRecentUplineColumn != 'distributorStatus', 'fa-sort-asc': (sortRecentUplineColumn  == 'distributorStatus' && !isRecentUplineDesc), 'fa-sort-desc': (sortRecentUplineColumn  == 'distributorStatus' && isRecentUplineDesc) }"></i>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="upLineDistributorDetails.length > 0">
        <tr
          *ngFor="let uplineDistributor of upLineDistributorDetails | paginate: { id:'recentUplineReportTableId', itemsPerPage: uplineRecentpageSize, currentPage: uplineRecentpageNumber, totalItems: uplineRecentpageCount }">
          <td *ngIf="uplineDistributor.rowNumber">
            {{uplineDistributor.rowNumber}}
          </td>
          <td *ngIf="uplineDistributor.distributorId">
            <a [routerLink]=""
              (click)="getAccountDetails(uplineDistributor.distributorId,uplineDistributor.operatingCompanyCode, uplineDistributor?.name, uplineDistributor.level)">
              {{uplineDistributor.distributorId | distributorIdFormat}}</a>
          </td>
          <td *ngIf="uplineDistributor.name">
            {{uplineDistributor.name}}
          </td>
          <td *ngIf="uplineDistributor.state">
            {{uplineDistributor.state}}
          </td>
          <td *ngIf="uplineDistributor.operatingCompanyCode">
            {{uplineDistributor.operatingCompanyCode}}
          </td>
          <td *ngIf="uplineDistributor.level">
            {{uplineDistributor.level}}
          </td>
          <td>
            {{uplineDistributor?.currentMonthActive == 'true' && uplineDistributor?.currentMonthActive != null   ? 'Yes' : 'No'}}
          </td>
          <td *ngIf="uplineDistributor.distributorStatus">
            {{uplineDistributor.distributorStatus}}
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="upLineDistributorDetails.length===0 && !showUpline">
        <tr>
          <td colspan="8"  class="text-center">
            {{'customer-service.No records found' | translate | translateKey}}.
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Start account Restriction Popup-->
    <div *ngIf="accountRestriction">
      <account-restriction-popup [memberDetails]="memberDetails" (closeModal)="closeModal($event)"></account-restriction-popup>
    </div>
    <!-- End account Restriction Popup-->

    <!-- <div class="row"> -->
    <div class="upline-report-position" *ngIf="upLineDistributorDetails.length > 0">
      <span>{{uplineRecentpageCount}} {{'store-user.record(s) found' |translate | translateKey}}</span>
    </div>
    <div class="pull-right" *ngIf="upLineDistributorDetails.length > 0">
      <pagination-controls (pageChange)="recentUplineReportPageChange($event)" id="recentUplineReportTableId"
        class="pull-right"></pagination-controls>
    </div>
    <!-- </div> -->
  </div>

  <modal #accountdetails>
    <modal-header>
      <div class="color-blue">{{'uplinereport.ACCOUNT DETAILS' |translate | translateKey}}</div>
    </modal-header>
    <modal-content *ngIf="accountDetails">
      <!-- <div class="mw-500 mx-auto"> -->
      <div *ngIf="accountDetails" class="distributorInfo">
        <div>
          <span class="header-font bold">{{accountDetails.name | titlecase}} </span>
        </div>
        <div>
          <span><a class="pointerstyle"  (keyup.enter)="navigateToFBOProfile(accountDetails.distributorId,accountDetails.level, accountDetails.name)"
            (click)="navigateToFBOProfile(accountDetails.distributorId,accountDetails.level, accountDetails.name)">{{accountDetails.distributorId |distributorIdFormat}} </a></span>
          <span *ngIf="accountDetails.level"> | </span>
          <span>{{accountDetails.level | titlecase}}</span>
        </div>
      </div>
      <div class="account-details">
        <div class="mb-10">
          <div>{{accountDetails.addressLine1}},{{accountDetails.city}}</div>
          <div>{{accountDetails.zipCode}}</div>
          <div>{{accountDetails.email}}</div>
        </div>
        <div class="mb-10">
          <div class="row">
            <div class="col-md-4">{{'uplinereport.Next Autoship Date' |translate | translateKey}}</div>
            <div *ngIf="accountDetails.nextAutoshipDate" class="col-md-6">
              {{accountDetails.nextAutoshipDate | date:'dd-MMM-yyyy'}}</div>
            <div *ngIf="!accountDetails.nextAutoshipDate" class="col-md-6">NA</div>
          </div>
          <div class="row">
            <div class="col-md-4">{{'uplinereport.Join Date' |translate | translateKey}}</div>
            <div class="col-md-6">{{accountDetails.joinDate | date:'dd-MMM-yyyy'}}</div>
          </div>
        </div>
        <div class="mb-10">
          <div><a (click)="getRecentOrderHistoryDetails(accountDetails.distributorId, accountDetails.homeCountry)">
              {{'uplinereport.Order History' |translate | translateKey}}</a></div>
        </div>
      </div>
      <div class="pull-right pad-r-8">
        <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUpforAccountDetails()">
          {{'config-system.CANCEL' |translate |translateKey}}
        </button>
      </div>
    </modal-content>
  </modal>


  <modal #accountorderhistory class="account-order-popup">
    <modal-header>
      <div class="color-blue">{{'uplinereport.ORDER HISTORY' |translate | translateKey}}</div>
    </modal-header>
    <modal-content *ngIf="accountDetails">
      <!-- <div class="mw-500 mx-auto"> -->
      <div *ngIf="accountDetails" class="distributorInfo">
        <div>
          <span class="header-font bold">{{accountDetails.name | titlecase}} </span>
        </div>
        <div>
          <span>{{accountDetails.distributorId |distributorIdFormat}} </span>
          <span *ngIf="accountDetails.level"> | </span>
          <span>{{accountDetails.level | titlecase}}</span>
        </div>
      </div>
      <div class=" account-order-history">
        <div class="account-order-table">
          <table class="table table-striped account-order-table table-header">
            <thead>
              <tr>
                <!-- <th (keyup.enter)="sortOrderHistoryDetailsByColumn('orderplaceddate')"
                                    (click)="sortOrderHistoryDetailsByColumn('orderplaceddate')"> -->
                <th> {{'uplinereport.Order Date' |translate | translateKey}}
                  <!-- <i class="font-12 fa fa-sort"
                                        [ngClass]="{'fa-sort': sortRecentOrderHistoryColumn != 'orderplaceddate', 'fa-sort-asc': (sortRecentOrderHistoryColumn  == 'orderplaceddate' && !isRecentOrderHistoryDesc), 'fa-sort-desc': (sortRecentOrderHistoryColumn  == 'orderplaceddate' && isRecentOrderHistoryDesc) }"></i> -->
                </th>
                <th>{{'uplinereport.Order Total' |translate | translateKey}}</th>
                <th>{{'uplinereport.Currency' |translate | translateKey}}</th>
                <th>{{'uplinereport.Total CC' |translate | translateKey}}</th>
                <th>{{'uplinereport.Country' |translate | translateKey}}</th>
              </tr>
            </thead>

          </table>
        </div>

        <div class="tbl-content account-order-table">
          <table class="table table-striped">
            <tbody *ngIf="orderHistoryDetails.length > 0">
              <tr
                *ngFor="let orderHistory of orderHistoryDetails | paginate: { id:'recentOrderHistoryTableId', itemsPerPage: recentpageSize, currentPage: recentpageNumber, totalItems: recentpageCount }">
                <td *ngIf="orderHistory.orderDate" style="width: 20%">
                  {{orderHistory.orderDate}}
                </td>
                <td *ngIf="orderHistory.orderTotal" style="width: 20%">
                  {{orderHistory.orderTotal}}
                </td>
                <td *ngIf="orderHistory.currency" style="width: 20%">
                  {{orderHistory.currency}}
                </td>
                <td *ngIf="orderHistory.totalCC >=0" style="width: 21%">
                  {{orderHistory.totalCC}}
                </td>
                <td *ngIf="orderHistory.country" style="width: 15%">
                  {{orderHistory.country}}
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="orderHistoryDetails.length===0 && !show">
              <tr>
                <td colspan="3"  class="text-center">
                  {{'customer-service.No records found' | translate | translateKey}}.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="account-position account-pagination" *ngIf="orderHistoryDetails.length > 0">
            <span>{{recentpageCount}} {{'store-user.record(s) found' |translate | translateKey}}</span>
          </div>
          <div class="pull-right account-pagination" *ngIf="orderHistoryDetails.length > 0">
            <pagination-controls (pageChange)="recentOrderHistoryPageChange($event)" id="recentOrderHistoryTableId"
              class="pull-right"></pagination-controls>
          </div>
        </div>
      </div>
      <div class="row account-order-cancel">
        <div class="pull-right pad-r-8">
          <button class="btn grey-button" tabindex="0" type="button"
            (click)="closePopUpforAccountOrderHistoryDetails()">
            {{'config-system.CANCEL' |translate |translateKey}}
          </button>
        </div>
      </div>
    </modal-content>

  </modal>
</section>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/upline-report.component.html